module.exports = __webpack_public_path__ + "static/img/banner-img.508e5bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newsCenter/banner-img.png
// module id = slLH
// module chunks = 44